import {
  login,
  verifyMfa,
  resendMfa,
  resetPassowrd,
  checkResetToken,
  getAllQuestions,
  verifyAllQuestionsForResetPassword,
  resetPasswordForForget,
  setPasswordOnboarding,
  getAllQuestionsList,
  SaveAllQuestionsForNewPassword,
  checkInviteToken,
  refreshToken,
} from '../Services/auth';

const LoginAction = async (data) => {
  const result = await login(data);
  return result;
};

const VerifyMfaAction = async (data) => {
  const result = await verifyMfa(data);
  return result;
};

const ResendMfaAction = async (data) => {
  const result = await resendMfa(data);
  return result;
};

const resetPassowrdAction = async (data) => {
  const result = await resetPassowrd(data);
  return result;
};

const verifyTokenreset = async (data) => {
  const result = await checkResetToken(data);
  return result;
};

const verifyTokenInvitation = async (data) => {
  const result = await checkInviteToken(data);
  return result;
};

const getAllQuestionsAction = async (data) => {
  const result = await getAllQuestions(data);
  return result;
};

const getAllQuestionsForSavePasswordAction = async (data) => {
  const result = await getAllQuestionsList(data);
  return result;
};

const resetPasswordForForgetAction = async (data) => {
  const result = await resetPasswordForForget(data);
  return result;
};

const verifyAllQuestionsForResetPasswordAction = async (data) => {
  const result = await verifyAllQuestionsForResetPassword(data);
  return result;
};

const saveAllQuestionsForNewPassword = async (data) => {
  const result = await SaveAllQuestionsForNewPassword(data);
  return result;
};

const SavePasswordForInviteAction = async (data) => {
  const result = await setPasswordOnboarding(data);
  return result;
};

const refreshTokenAction = async () => {
  const result = await refreshToken({
    token: localStorage.getItem('hema-token'),
    refreshToken: localStorage.getItem('hema-token-refresh'),
  });
  return result;
};

export {
  VerifyMfaAction,
  ResendMfaAction,
  SavePasswordForInviteAction,
  resetPasswordForForgetAction,
  LoginAction,
  resetPassowrdAction,
  verifyTokenInvitation,
  getAllQuestionsAction,
  verifyAllQuestionsForResetPasswordAction,
  getAllQuestionsForSavePasswordAction,
  saveAllQuestionsForNewPassword,
  verifyTokenreset,
  refreshTokenAction,
};
